import { render, staticRenderFns } from "./tree-branch.vue?vue&type=template&id=7acb53be"
import script from "./tree-branch.vue?vue&type=script&lang=js"
export * from "./tree-branch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports